import { SlotButton } from './SlotButton';

export default SlotButton;
